// mutations
const SCHOOLROUTES_MESSENGER_ALL = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MESSENGER_FORM = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MESSENGER_SHOW = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MESSENGER_CREATE = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MESSENGER_UPDATE = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MESSENGER_DELETE = (state, schoolRoutesMessenger) => {
  if (schoolRoutesMessenger.code === 1) {
    state.schoolRoutesMessenger = schoolRoutesMessenger.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMessenger.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTES_MESSENGER_ALL,
  SCHOOLROUTES_MESSENGER_FORM,
  SCHOOLROUTES_MESSENGER_SHOW,
  SCHOOLROUTES_MESSENGER_CREATE,
  SCHOOLROUTES_MESSENGER_UPDATE,
  SCHOOLROUTES_MESSENGER_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/messenger/mutations.js